module.exports = __webpack_public_path__ + "static/media/about_card_min.032947fc.jpg";